import AutoLayerManager from "../../autolayermanager/AutoLayerManager";

declare var diy: any;

export class App {
    protected toolbar: any;
    protected layerManager: AutoLayerManager;

    static getNotificationApi() {
        let ns = (<any>window).diy.editor.notifications;
        return ns.api;
    }

    setToolbar(toolbar: any) {
        this.toolbar = toolbar;
    }

    setLayerManager(lm: AutoLayerManager) {
        this.layerManager = lm;
    }

    initApi() {
        let ns = diy.core.namespace('diy.editor.notifications');

        let NotificationFactory: any = require('./NotificationFactory');
        ns.Notifications = NotificationFactory.notificationTypes;
        ns.NotificationFactory = new NotificationFactory();

        let NotificationQueue: any = require('./NotificationQueue');
        let queue = new NotificationQueue();
        ns.queue = queue;
        ns.api = {
            ready: queue.ready.bind(queue)
        };

        ns.BubbleManager = require('./bubble-manager');
    }

    getApi() {
        //HACK: tidy up the namespaces
        let ns = (<any>window).diy.editor.notifications;
        return ns.api;
    }

    init() {
        let ns = diy.core.namespace('diy.editor.notifications');

        let notpublishednotification: any = require('./init/notpublishednotification');
        notpublishednotification.init();

        require('./chatnotification');
        require('./upgradeBrowserN');
        require('./nodomainnotification');

        require('./directives/diynotification');
        let notificationModule: any = require('./notification-module');
        notificationModule.setToolbar(this.toolbar);
        notificationModule.setLayerManager(this.layerManager);
        require('./flyout-module');

        let NotificationCenter: any = require('./NotificationCenter');
        ns.notificationCenter = new NotificationCenter(this.toolbar);
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notification/App.ts
 **/